import { NgModule, ModuleWithProviders } from '@angular/core';
import { ButtonStateService } from './buttonstate/button-state.service';
import { CmsAlarmsService } from './data-services/monitor/cms-alarms/cms-alarms.service';
import { ConditionComponentGraphService } from './data-services/monitor/condition-component-graph/condition-component-graph.service';
import { ConditionComponentInfoService } from './data-services/monitor/condition-component-information/condition-component-information.service';
import { ComponentModelService } from './data-services/monitor/component-model/component-model.service';
import { OverviewService } from './data-services/monitor/overview/overview.service';
import { PerformanceFactsService } from './data-services/monitor/performance-facts/performance-facts.service';
import { PerformanceMonitoringService } from './data-services/monitor/performance-monitoring/performance-monitoring';
import { PowerForecastService } from './data-services/monitor/power-forecast/power-forecast.service';
import { HelperService } from './helper-service/helper.service';
import { MapDataService } from './data-services/monitor/map-data/map-data.service';
import { TurbineCockpitService } from './data-services/monitor/turbine-cockpit/turbine-cockpit.service';
import { FullsizeService } from './fullsize/fullsize.service';
import { ProvidersColorsService } from './theme-colors/providers-colors.service';
import { SortService } from './sort-service/sort.service';
import { OverviewBoardService as OverviewBoardServiceApollo } from './data-services/overview-board/overviewboard.service';
import { ParkPositionService } from './park-position/parkPosition.service';
import { LastSeenTurbinesService } from './last-seen-turbines/last-seen-turbines.service';
import { ForecastGraphService } from './data-services/forecast/forecast-graph/forecast-graph.service';
import { NewAlarmsService } from './data-services/monitor/alarms/new-alarms.service';
import {CheckRevenuesFactsService} from './data-services/check-revenues/check-revenues-facts/check-revenues-facts.service';
import {ExcelExportService} from './export/excel/excel-export.service';
import {VersionService} from './version-service/version.service';
import { LanguageService } from './language/language.service';
import {
  AcknowledgmentTicketsService
} from './data-services/troubleshoot/acknowledgment-tickets/acknowledgment-tickets.service';
import { DateTimeFormatService } from './date-time-format/date-time-format.service';

const SERVICES = [
  ButtonStateService,
  CmsAlarmsService,
  ConditionComponentGraphService,
  ConditionComponentInfoService,
  ComponentModelService,
  OverviewService,
  PerformanceFactsService,
  PerformanceMonitoringService,
  PowerForecastService,
  MapDataService,
  HelperService,
  TurbineCockpitService,
  FullsizeService,
  ProvidersColorsService,
  SortService,
  OverviewBoardServiceApollo,
  LastSeenTurbinesService,
  ParkPositionService,
  ForecastGraphService,
  NewAlarmsService,
  CheckRevenuesFactsService,
  ExcelExportService,
  VersionService,
  LanguageService,
  AcknowledgmentTicketsService,
	DateTimeFormatService
];

@NgModule({})

export class ServicesModule {
  static forRoot(): ModuleWithProviders <ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: SERVICES
    };
  }
}
